/** @format */
import axios from 'axios';

/**
 * Get poll results
 *
 * @param {Object} data Data
 *
 * @return Promise for resolve, reject
 */
export const getPollStatus = function (data) {
    return axios
        .post('/poll/status', data.data)
        .then((response) => response.data);
};

/**
 * Vote on a poll
 *
 * @param {Object} data Data
 *
 * @return Promise for resolve, reject
 */
export const vote = function (data) {
    return axios
        .post('/poll/vote', data.data)
        .then((response) => response.data);
};

/**
 * Unvote on a poll
 *
 * @param {Object} data Data
 *
 * @return Promise for resolve, reject
 */
export const unvote = function (data) {
    return axios
        .post('/poll/unvote', data.data)
        .then((response) => response.data);
};